import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { metalDictVi } from "@/lib/shop/products/metal";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/vi/shop_/metal")({
  head: () => ({
    ...buildProductHead(metalDictVi),
    links: alternateLinkList("/shop/metal", "vi"),
  }),
  component: () => <ProductPage dict={metalDictVi} />,
});
